

const variantClasses= {
  info: "bg-blue-50 border-blue-400 text-blue-700",
  danger: "bg-red-50 border-red-400 text-red-700",
  success: "bg-green-50 border-green-400 text-green-700",
  warning: "bg-yellow-50 border-yellow-400 text-yellow-700",
};

const Message = ({ variant = "info", children }) => {
  return (
    <div
      className={`border px-4 py-3 rounded-md text-sm ${variantClasses[variant]}`}
      role="alert"
    >
      {children}
    </div>
  );
};

export default Message;
